import React, { createContext, useContext, useState } from "react";

const SalaryReviseContext = createContext();

export const useSalaryRevise = () => {
  const context = useContext(SalaryReviseContext);
  if (!context) {
    throw new Error("useShiftRota must be used within a ShiftRotaProvider");
  }
  return context;
};

export const SalaryReviseProvider = ({ children }) => {
  const [newTemplateData, setNewTemplateData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [prefillDetails, setPrefillDetails] = useState(false);
  const [showReprocessDialog, setShowReprocessDialog] = useState(false);
  const [templateData, setTemplateData] = useState([]);
  const [dataUpdated, setDataupdated] = useState(false);
  const [handleButtonLoader, setHandleButtonLoder] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [previewData, setPreviewData] = useState([]);
  const [triggerOnce, setTriggerOnce] = useState(true);
  const [load, setLoad] = useState(true);
  const [handleLoader, setHandleLoader] = useState(true);
  const [clearValues, setClearValues] = useState(false);
  const [getDate, setGetDate] = useState(false);

  const value = {
    newTemplateData,
    setNewTemplateData,
    editData,
    setEditData,
    prefillDetails,
    setPrefillDetails,
    showReprocessDialog,
    setShowReprocessDialog,
    templateData,
    setTemplateData,
    dataUpdated,
    setDataupdated,
    handleButtonLoader,
    setHandleButtonLoder,
    tabValue,
    setTabValue,
    previewData,
    setPreviewData,
    triggerOnce,
    setTriggerOnce,
    load,
    setLoad,
    handleLoader,
    setHandleLoader,
    clearValues,
    setClearValues,
    getDate,
    setGetDate,
  };

  return (
    <SalaryReviseContext.Provider value={value}>
      {children}
    </SalaryReviseContext.Provider>
  );
};
